<body class="active-carry-over-loads">
  <div class="active-carry-over-loads-container">
    <h3 class="page-title">{{ CONST.HEADER }}</h3>
    <ion-row>
      <ion-col
        [formGroup]="carryLoadsForm"
        class="custom-col ion-margin-bottom"
      >
        <!-- Close date -->
        <div class="sort-date-picker-container">
          <p class="date-label">
            {{ CONST.CLOSE_DATE }} <span class="required-field">*</span>
          </p>
          <app-form-date-picker
            [icon]="SRC.CALENDAR"
            [placeholder]="CONST.SELECT_DATE"
            [minDate]="minDate"
            [maxDate]="maxDate"
            formControlName="closeDate"
          ></app-form-date-picker>
        </div>

        <!-- Close time -->
        <div class="close-time">
          <app-form-time-picker
            [headerText]="CONST.CLOSE_TIME"
            [defaultStartTime]="defaultCloseTime"
            [required]="true"
            [form]="carryLoadsForm"
            [control]="'closeTime'"
            (inputChangedEvent)="timeChanged($event)"
          ></app-form-time-picker>
        </div>

        <!-- Percent full -->
        <div class="percent-full">
          <app-form-input-field
            [label]="CONST.PERCENT_FULL"
            [required]="true"
            [maxLength]="3"
            [regexType]="SpecialCharacters.NUMBER_ONLY"
            formControlName="percentFull"
          >
          </app-form-input-field>
        </div>

        <div class="btn-container">
          <ion-button
            class="submit-btn"
            [disabled]="
              !carryLoadsForm.valid || !(selectedUldNumberIndex !== null)
            "
            (click)="submit()"
            onkeydown="submit()"
          >
            {{ CONST.CLOSE }}
          </ion-button>
        </div>
      </ion-col>
      <!-- Icons -->
      <ion-col class="top-icons ion-no-padding action-btn-column">
        <ion-button
          class="key-update-btn"
          [disabled]="!(selectedUldNumberIndex !== null)"
          [ngClass]="{
            'active-clear-btn': selectedUldNumberIndex !== null,
          }"
          (click)="loadKeyUpdate()"
          onkeydown="loadKeyUpdate()"
          [fill]="'outline'"
        >
          {{ CONST.LOAD_KEY_UPDATE }}
        </ion-button>
      </ion-col>
    </ion-row>
    <!-- Table -->
    <div class="active-carry-over-loads-table-container">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        id="excel-table"
        class="active-carry-over-loads-table"
      >
        <caption>
          {{
            CONST.HEADER
          }}
        </caption>
        <!-- ULD_NUMBER -->
        <ng-container matColumnDef="uldNumber">
          <th mat-header-cell *matHeaderCellDef id="uld-number-headers">
            <app-table-search-component
              [columnName]="COLUMNTEXT.ULD_NUMBER"
              [control]="uldNumberData.formControl"
              [maxLength]="10"
              [placeholder]="CONST.SEARCH"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>
          <td
            headers="uld-number-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let activeCarryOverLoads; let i = index"
          >
            <ion-radio-group
              [(ngModel)]="selectedUldNumberIndex"
              class="radio-group"
              (ionChange)="onRadioChange(activeCarryOverLoads)"
            >
              <ion-item lines="none" class="item">
                <ion-radio
                  slot="start"
                  [value]="i"
                  class="radio-btn"
                ></ion-radio>
                <ion-label
                  class="btn-label"
                  (click)="openOutboundPopup(activeCarryOverLoads)"
                  onkeydown="openOutboundPopup(activeCarryOverLoads)"
                  >{{ activeCarryOverLoads.uldNumber }}</ion-label
                >
              </ion-item>
            </ion-radio-group>
          </td>
        </ng-container>

        <!-- ULD_TYPE -->
        <ng-container matColumnDef="uldType">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="uld-type-headers"
            class="uld-column-header"
          >
            <ion-row class="th-text"> {{ COLUMNTEXT.ULD_TYPE }} </ion-row>
            <div class="empty-item"></div>
          </th>

          <td
            headers="uld-type-headers"
            class="selectable cursor-pointer uld-type"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.uldType }}
          </td>
        </ng-container>

        <!-- SEAL_NUMBER -->
        <ng-container matColumnDef="sealNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="seal-number-headers"
            class="column-width-175"
          >
            <app-table-search-component
              [columnName]="COLUMNTEXT.SEAL_NUMBER"
              [control]="sealNumberData.formControl"
              [maxLength]="12"
              [placeholder]="CONST.SEARCH"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>

          <td
            headers="seal-number-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.sealNumber }}
          </td>
        </ng-container>

        <!-- LOAD_KEY -->
        <ng-container matColumnDef="loadKey">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="load-key-headers"
            class="column-width-175 small-search-input"
          >
            <ion-row class="th-text"> {{ COLUMNTEXT.LOAD_KEY }} </ion-row>
            <div class="empty-item"></div>
          </th>

          <td
            headers="load-key-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.loadKey }}
          </td>
        </ng-container>

        <!-- LOAD_CHART -->
        <ng-container matColumnDef="loadChart">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="load-chart-headers"
            class="column-width-175 small-search-input"
          >
            <ion-row class="th-text"> {{ COLUMNTEXT.LOAD_CHART }} </ion-row>
            <div class="empty-item"></div>
          </th>

          <td
            headers="load-chart-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.loadChart }}
          </td>
        </ng-container>

        <!-- MOVEMENT -->
        <ng-container matColumnDef="movement">
          <th mat-header-cell *matHeaderCellDef id="parent-uld-headers">
            <ion-row class="th-text"> {{ COLUMNTEXT.MOVEMENT }} </ion-row>
            <div class="empty-item"></div>
          </th>

          <td
            headers="parent-uld-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.movement }}
          </td>
        </ng-container>

        <!-- ULD_COUNT -->
        <ng-container matColumnDef="uldCount">
          <th mat-header-cell *matHeaderCellDef id="uldCount-headers">
            <ion-row class="th-text"> {{ COLUMNTEXT.ULD_COUNT }} </ion-row>
            <div class="empty-item"></div>
          </th>

          <td
            headers="uldCount-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            <div
              [class]="
                outboundScan.uldCount > 0 ? 'uld-count-text' : 'prevent-click'
              "
              (click)="openUldCountPopup(outboundScan, i)"
              onkeydown="openUldCountPopup(outboundScan, i)"
            >
              {{ outboundScan.uldCount }}
            </div>
          </td>
        </ng-container>

        <!-- LOOSE_COUNT -->
        <ng-container matColumnDef="pkgCount">
          <th mat-header-cell *matHeaderCellDef id="pkgCount-headers">
            <ion-row class="th-text"> {{ COLUMNTEXT.PKG_COUNT }} </ion-row>
            <div class="empty-item"></div>
          </th>

          <td
            headers="pkgCount-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.pkgCount }}
          </td>
        </ng-container>

        <!-- LOAD_CREATE_DATE -->
        <ng-container matColumnDef="loadCreateDate">
          <th mat-header-cell *matHeaderCellDef id="loadCreateDate-headers">
            <ion-row class="th-text"
              >{{ COLUMNTEXT.LOAD_CREATE_DATE }}
            </ion-row>
            <div class="empty-item"></div>
          </th>

          <td
            headers="loadCreateDate-headers"
            class="selectable cursor-pointer load-create-date"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.loadCreateDate }}
          </td>
        </ng-container>

        <!-- ORIGIN_SORT -->
        <ng-container matColumnDef="origSort">
          <th mat-header-cell *matHeaderCellDef id="originSort-headers">
            <ion-row class="th-text">{{ COLUMNTEXT.ORIGIN_SORT }} </ion-row>
            <div class="empty-item"></div>
          </th>

          <td
            headers="originSort-headers"
            class="selectable cursor-pointer origin-sort"
            mat-cell
            *matCellDef="let outboundScan; let i = index"
          >
            {{ outboundScan.origSort }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let i = dataIndex"
        ></tr>

        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell no-border no-results"
            [attr.colspan]="displayedColumns.length"
          >
            <app-no-results-found></app-no-results-found>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
